import { Swiper, Navigation } from 'swiper'

Swiper.use([Navigation])

export default () => {
    // eslint-disable-next-line
    new Swiper('.column-slider .swiper-container', {
        slidesPerView: 1,
        spaceBetween: 50,
        navigation: {
            nextEl: '.column-slider__next',
            prevEl: '.column-slider__previous',
        },
    })
}
